import { combineReducers } from 'redux';

import addAbReducer from 'reducers/abReducer';
import commonReducers from 'reducers/commonReducers';

export default (extraReducers = {}) => combineReducers(addAbReducer({ ...commonReducers, ...extraReducers }));
